<script setup>
import { computed } from 'vue';
import { trans, transchoice } from '@tools/translation';
import { formatNumber } from '@tools/number';
import { useOfficeOfferStore } from '@stores/useOfficeOfferStore';
import OfferPreview from '@pages/offer-page/common/OfferPreview.vue';

const props = defineProps({
  offer: {
    type: Object,
    required: true,
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  isAuthorOrSameOrga: {
    type: Boolean,
    required: true,
  },
});

const isChecked = defineModel('checked', { type: Boolean, required: true });
const chosenTeamSize = defineModel('chosenTeamSize', { type: Number, required: true });

const isOpenSpace = computed(() => useOfficeOfferStore().isOpenSpace(props.offer));

const emit = defineEmits([ 'change', 'updateCapacity', 'blurCapacity' ]);

const showCapacityForm = computed(() => isOpenSpace.value && isChecked.value);
</script>

<template>
  <div class="office-chooser__choice">
    <input
      :id="`offer-hash-${offer.hash_id}`"
      v-model="isChecked"
      class="office-chooser__choice__checkbox"
      type="checkbox"
      :disabled="isAuthorOrSameOrga"
      @change="emit('change')"
    >

    <label
      :for="`offer-hash-${offer.hash_id}`"
      class="office-chooser__choice__content"
      :class="{ selected: isChecked }"
    >
      <OfferPreview
        :offer="offer"
        class="office-chooser__choice__preview"
        :class="{ selected: isChecked, 'show-capacity-form': showCapacityForm }"
      />

      <div
        v-show="showCapacityForm"
        class="office-chooser__choice__capacity"
        :class="{ selected: isChecked }"
      >
        <input
          :id="`offer-teamsize-${offer.hash_id}`"
          v-model="chosenTeamSize"
          class="office-chooser__choice__capacity-field"
          type="number"
          :min="1"
          :max="offer.capacity"
          :disabled="isAuthorOrSameOrga"
          :class="{ error: hasError }"
          @keyup="emit('updateCapacity', offer.hash_id)"
          @blur="emit('blurCapacity')"
          @click.prevent
        >

        <span>
          {{ trans('multioffice.on') }} {{ formatNumber(offer.capacity) }}
          {{ transchoice('multioffice.available', { count: offer.capacity }) }}
        </span>
      </div>
    </label>
  </div>
</template>
